export enum InvestorsOrderBy {
  Default = 0,
  Name = 1,
  NameDesc = 2,
  Status = 3,
  StatusDesc = 4,
  AmountHighToLow = 5,
  AmountLowToHigh = 6,
  TimeAddedNewToOld = 7,
  TimeAddedOldToNew = 8,
  RankingHighToLow = 9,
  RankingLowToHigh = 10,
  CallDateNewToOld = 11,
  CallDateOldToNew = 12,
  AccreditationAsc = 13,
  AccreditationDesc = 14
}


// tslint:disable-next-line:no-namespace
export namespace InvestorsOrderBy {
  export function toString(orderBy: InvestorsOrderBy): string {
    switch (orderBy) {
      case InvestorsOrderBy.Default:
      case InvestorsOrderBy.TimeAddedNewToOld:
        return 'Time Added: New - Old';
      case InvestorsOrderBy.TimeAddedOldToNew:
        return 'Time Added: Old - New';
      case InvestorsOrderBy.Name:
        return 'Name: A-Z';
      case InvestorsOrderBy.NameDesc:
        return 'Name: Z-A';
      case InvestorsOrderBy.Status:
        return 'Status: Ascending';
      case InvestorsOrderBy.StatusDesc:
        return 'Status: Descending';
      case InvestorsOrderBy.AmountHighToLow:
        return 'Amount: High - Low';
      case InvestorsOrderBy.AmountLowToHigh:
        return 'Amount: Low - High';
      case InvestorsOrderBy.RankingHighToLow:
        return 'Ranking: Higher - Lower';
      case InvestorsOrderBy.RankingLowToHigh:
        return 'Ranking: Lower - Higher';
      case InvestorsOrderBy.CallDateNewToOld:
        return 'Call Date: New - Old';
      case InvestorsOrderBy.CallDateOldToNew:
        return 'Call Date: Old - New';
      case InvestorsOrderBy.AccreditationAsc:
        return 'Accreditation: A-Z';
      case InvestorsOrderBy.AccreditationDesc:
        return 'Accreditation: Z-A';

      default:
        return 'Default';
    }
  }

  export function listAll(allowInvestorName = true) {
    if(allowInvestorName){
      return [
        InvestorsOrderBy.Name,
        InvestorsOrderBy.NameDesc,
        InvestorsOrderBy.Status,
        InvestorsOrderBy.StatusDesc,
        InvestorsOrderBy.AmountHighToLow,
        InvestorsOrderBy.AmountLowToHigh,
        InvestorsOrderBy.CallDateNewToOld,
        InvestorsOrderBy.CallDateOldToNew,
        InvestorsOrderBy.AccreditationAsc,
        InvestorsOrderBy.AccreditationDesc,
        InvestorsOrderBy.TimeAddedNewToOld,
        InvestorsOrderBy.TimeAddedOldToNew,
        InvestorsOrderBy.RankingHighToLow,
        InvestorsOrderBy.RankingLowToHigh
      ];
    }
    else{
      return [
        InvestorsOrderBy.Status,
        InvestorsOrderBy.StatusDesc,
        InvestorsOrderBy.AmountHighToLow,
        InvestorsOrderBy.AmountLowToHigh,
        InvestorsOrderBy.CallDateNewToOld,
        InvestorsOrderBy.CallDateOldToNew,
        InvestorsOrderBy.AccreditationAsc,
        InvestorsOrderBy.AccreditationDesc,
        InvestorsOrderBy.TimeAddedNewToOld,
        InvestorsOrderBy.TimeAddedOldToNew,
        InvestorsOrderBy.RankingHighToLow,
        InvestorsOrderBy.RankingLowToHigh
      ];
    }
    
  }

  export function parse(sortStr: string): InvestorsOrderBy {
    return InvestorsOrderBy[sortStr];
  }
}

export default InvestorsOrderBy;

